import * as _ from 'lodash';

import { TicketStatusId, TicketViewModel } from '../../../models/';
import { guidEmpty } from '../../../common/';

export function dropTicket(
    data: any,
    ticketStatusId: number,
    currentUserGuid: string,
    ticketViewModelList: TicketViewModel[],
    saveTicket: ({ ticket: Ticket }) => angular.IPromise<void>
) {
    if (data && data.itemId) {
        const ticketId = +data.itemId.replace('item', '');
        if (!isNaN(ticketId)) {
            const foundTicketViewModel = _.find(ticketViewModelList, ticketViewModel => ticketViewModel.model.id === ticketId);
            if (foundTicketViewModel && ticketStatusId !== foundTicketViewModel.model.statusId) {
                if (foundTicketViewModel.model.statusId === 1 && ticketStatusId === 2) {
                    foundTicketViewModel.model.assignedUser = currentUserGuid;
                } else if (ticketStatusId === TicketStatusId.New) {
                    foundTicketViewModel.model.assignedUser = guidEmpty;
                }
                foundTicketViewModel.model.statusId = ticketStatusId;

                // TicketViewModel to Ticket
                const ticketToSave = foundTicketViewModel.model;

                // Save status change
                return saveTicket({ ticket: ticketToSave })
                    .then(() => ticketToSave);
            }
        }
    }
}